export const updateDataLink = (link: string, objectId?: string | number) => {
    if (typeof objectId !== 'undefined') {
        return link.replace('{objectId}', objectId.toString());
    }
    return link;
};
